var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('v-radio',{staticClass:"mt-0",attrs:{"color":"white","label":_vm.label,"value":_vm.value,"dark":!_vm.lighten,"disabled":_vm.disabled}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }